import type { SiteConfig, FaqItem } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ToggleField, ListEditor } from './fields.tsx';

export function FaqSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const f = config.faq;
  const set = (patch: Partial<SiteConfig['faq']>) => update({ faq: { ...f, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>FAQ</h2>
      <TextField label="Titre de la section" value={f.title} onChange={(v) => set({ title: v })} />
      <ListEditor<FaqItem>
        items={f.items}
        onChange={(items) => set({ items })}
        itemLabel="une question"
        newItem={() => ({ id: crypto.randomUUID(), question: 'Nouvelle question ?', answer: '', category: 'general', order: f.items.length, visible: true })}
        renderItem={(item, patch) => (
          <>
            <TextField label="Question" value={item.question} onChange={(v) => patch({ question: v })} />
            <TextAreaField label="Réponse" value={item.answer} onChange={(v) => patch({ answer: v })} />
            <TextField label="Catégorie" value={item.category} onChange={(v) => patch({ category: v })} />
            <ToggleField label="Visible" value={item.visible} onChange={(v) => patch({ visible: v })} />
          </>
        )}
      />
    </div>
  );
}
